import comp from "./AddAssignment";
export default comp;
